import Swiper, { Navigation, Pagination, Thumbs, Autoplay } from 'swiper';
import 'swiper/css';
require('fslightbox');

function defaultSwiperSettings(slidesPerView = 1, speed = 500) {
	return {
		modules: [Navigation, Pagination, Thumbs, Autoplay],
		speed: speed,
		slidesPerView: slidesPerView,
	};
}

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelectorAll('.hero-slider.swiper').length) {
		let nextNav = document.querySelector('.hero-button-next');
		let prevNav = document.querySelector('.hero-button-prev');

		const heroThumbsSlider = new Swiper('.hero-slider-thumbs', {
			...defaultSwiperSettings(5),
			spaceBetween: 16,
			watchSlidesProgress: true,
			navigation: {
				nextEl: nextNav,
				prevEl: prevNav,
			},
			breakpoints: {
				320: {
					slidesPerView: 4,
					spaceBetween: 9,
				},
				640: {
					slidesPerView: 4,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 5,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 16,
				},
				1280: {
					slidesPerView: 5,
					spaceBetween: 16,
				},
			},
		});

		const heroSlider = new Swiper('.hero-slider', {
			...defaultSwiperSettings(1),
			watchSlidesProgress: true,
			thumbs: {
				swiper: heroThumbsSlider,
			},
		});
	}
	if (document.querySelectorAll('.related-case-swiper.swiper')) {
		const relatedCaseSlider = new Swiper('.related-case-swiper', {
			...defaultSwiperSettings(1.1),
			spaceBetween: 20,
			breakpoints: {
				568: {
					slidesPerView: 2.3,
				},
				768: {
					slidesPerView: 3,
				},
			},
		});
	}
	if (document.querySelectorAll('.latest-news-swiper.swiper')) {
		const latestNewsSlider = new Swiper('.latest-news-swiper', {
			...defaultSwiperSettings(1.1),
			spaceBetween: 20,
			breakpoints: {
				568: {
					slidesPerView: 2.3,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		});
	}
	if (document.querySelectorAll('.related-events.swiper')) {
		const relatedCaseSlider = new Swiper('.related-events-swiper', {
			...defaultSwiperSettings(1.1),
			spaceBetween: 20,
			breakpoints: {
				568: {
					slidesPerView: 2.3,
				},
				768: {
					slidesPerView: 3,
				},
			},
		});
	}
	if (document.querySelectorAll('.image-slider-block')) {
		let gallerySliders = document.querySelectorAll('.image-slider-block');

		gallerySliders.forEach(function (slider) {
			let nextNav = slider.querySelector('.gallery-next');
			let prevNav = slider.querySelector('.gallery-prev');
			const playButton = slider.querySelector('#play');
			const pauseButton = slider.querySelector('#pause');

			const gallerySlider = new Swiper(
				slider.querySelector('.image-gallery-slider.slider'),
				{
					...defaultSwiperSettings(1, 1000),
					autoplay: true,
					loop: true,
					navigation: {
						nextEl: nextNav,
						prevEl: prevNav,
					},
				}
			);
			if (playButton && playButton.length) {
				playButton.addEventListener('click', function (event) {
					gallerySlider.autoplay.start();

					togglePlayIcon(true, playButton, pauseButton);
				});
			}

			if (pauseButton && pauseButton.length) {
				pauseButton.addEventListener('click', function (event) {
					gallerySlider.autoplay.stop();
					togglePlayIcon(false, playButton, pauseButton);
				});
			}

			function togglePlayIcon(play, playButton, pauseButton) {
				if (play) {
					playButton.classList.add('hidden');
					pauseButton.classList.remove('hidden');
				} else {
					pauseButton.classList.add('hidden');
					playButton.classList.remove('hidden');
				}
			}
		});
	}

	if (document.querySelectorAll('.gallery-lightbox-block')) {
		let galleryLightboxSliders = document.querySelectorAll(
			'.gallery-lightbox-block'
		);

		galleryLightboxSliders.forEach(function (slider) {
			let nextGalleryNav = slider.querySelector('.gallery-lightbox-next');
			let prevGalleryNav = slider.querySelector('.gallery-lightbox-prev');
			const galleryLightboxSlider = new Swiper(
				slider.querySelector('.gallery-lightbox-slider.slider'),
				{
					...defaultSwiperSettings(1.6),
					spaceBetween: 20,
					breakpoints: {
						568: {
							slidesPerView: 2.3,
						},
						768: {
							slidesPerView: 3,
							spaceBetween: 30,
						},
						1024: {
							slidesPerView: 4,
						},
					},
					navigation: {
						nextEl: nextGalleryNav,
						prevEl: prevGalleryNav,
					},
				}
			);
		});
	}
});
